import { Component } from './Component';
export class Material extends Component {
    constructor(color) {
        super();
        if (color)
            this.color = color;
        else
            this.color = 'red';
    }
    toString() {
        return this.color;
    }
}
//# sourceMappingURL=Material.js.map